"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GaEventEnum;
(function (GaEventEnum) {
    GaEventEnum["savePlanner"] = "save_planner";
    GaEventEnum["addToWishlist"] = "add_to_wishlist";
    GaEventEnum["addToCart"] = "add_to_cart";
    GaEventEnum["openPlanner"] = "open_planner";
})(GaEventEnum || (GaEventEnum = {}));
exports.default = GaEventEnum;
//# sourceMappingURL=GaEventEnum.js.map